module.exports = __webpack_public_path__ + "static/media/Close-icon-red.3fa789cd.svg";